import React, { createContext, useContext, ReactNode } from 'react'

interface FormSaveForLaterContextType {
  triggerSave: () => void
  registerSaveCallback: (callback: () => void) => void
  unregisterSaveCallback: () => void
}

const FormSaveForLaterContext = createContext<FormSaveForLaterContextType | undefined>(undefined)

export const FormSaveForLaterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  let saveCallback: (() => void) | null = null

  const registerSaveCallback = (callback: () => void) => {
    saveCallback = callback
  }

  const unregisterSaveCallback = () => {
    saveCallback = null
  }

  const triggerSave = () => {
    if (saveCallback) {
      saveCallback()
    }
  }

  return (
    <FormSaveForLaterContext.Provider value={{ triggerSave, registerSaveCallback, unregisterSaveCallback }}>
      {children}
    </FormSaveForLaterContext.Provider>
  )
}

export const useFormSaveForLater = () => {
  const context = useContext(FormSaveForLaterContext)
  if (!context) {
    throw new Error('useFormSaveForLater must be used within a FormSaveForLaterProvider')
  }
  return context
} 